import { useEffect, useState } from 'react';
import CustomModal from './CustomModal';
import { getOrderProductDetailsById } from '../service';
import instance from '../config/axios';
import {
  AddTokenModalProps,
  InvalidProductProps,
  OrderProductTokenList,
  OrderStatusCode,
} from '../interface/interface';
import { useNavigate } from 'react-router-dom';
import showToast from './ToastComponent';

const AddTokenModal = ({
  isTokenModalOpen,
  handleAddTokenCloseClick,
  orderId,
  accessToken,
}: AddTokenModalProps) => {
  const navigateTo = useNavigate();

  const [orderProductsList, setOrderProductList] = useState<
    Array<OrderProductTokenList>
  >([]);

  useEffect(() => {
    if (!orderId || !accessToken) return;

    getOrderProductDetailsById(accessToken, orderId).then((data) => {
      if (typeof data === 'number') {
        setOrderProductList([]);
        return;
      }

      setOrderProductList(
        data
          ?.filter(
            (d: { currentStatus: { id: number } }) =>
              d.currentStatus?.id === OrderStatusCode.INVALID,
          )
          ?.map((d: InvalidProductProps) => ({
            opId: d.id,
            productName: d.product.name,
            prescriptionCode: '',
            patientId: d.patientId,
            currentStatus: d.currentStatus,
          })),
      );
    });
  }, [orderId]);

  const handleInput = (id: number, value: string) => {
    const op = orderProductsList?.find((x) => x.opId === id);
    if (!op) {
      return;
    }

    op.prescriptionCode = value;
    setOrderProductList(() => [...orderProductsList]);
  };

  const submitRequest = () => {
    orderProductsList?.forEach((op) => {
      if (!op.prescriptionCode) {
        showToast({
          message: 'Empty token not allowed',
          type: 'warning',
        });
        return;
      }

      instance({
        method: 'PATCH',
        url: '/api/v1/order/products/add-token',
        data: {
          orderProductId: op.opId,
          prescriptionCode: op.prescriptionCode,
          patientId: op.patientId,
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            showToast({
              message: `${res.data.message}`,
              type: 'success',
            });
          } else {
            showToast({
              message: `${res.data.message}`,
              type: 'warning',
            });
          }
        })
        .catch((err) => {
          console.log(err);
          showToast({
            message: 'Error adding token to the order',
            type: 'error',
          });
          return;
        });
    });
    handleAddTokenCloseClick();
    navigateTo('/admin/orders');
  };

  return (
    <CustomModal
      isOpen={isTokenModalOpen}
      onClose={handleAddTokenCloseClick}
      header="Add Prescription Token"
      footer={
        <button
          className="text-base px-6 py-3 bg-secondary-cornflowerblue-400 text-white rounded-md"
          onClick={() => submitRequest()}
        >
          Save
        </button>
      }
      modalSize="w-5/12"
    >
      <div>
        <div className="flex">
          <label
            htmlFor="token"
            className="block text-base font-semibold text-primary-blue-500 w-1/2"
          >
            Product Name
          </label>
          <label
            htmlFor="token"
            className="block text-base font-semibold text-primary-blue-500 w-1/2"
          >
            Token
          </label>
        </div>
        {orderProductsList.map((opl, index) => (
          <div className="flex items-center mt-4" key={index}>
            <p className="mt-1 text-sm text-regular text-primary-blue-500 w-1/2">
              {opl.productName}
            </p>
            <input
              type="text"
              placeholder="Add Prescription token"
              className="p-2 border border-primary-blue-500 text-sm px-3 py-2 rounded-lg w-1/2"
              onChange={(e) => handleInput(opl.opId, e.target.value)}
            />
          </div>
        ))}
      </div>
    </CustomModal>
  );
};

export default AddTokenModal;
